import React from "react";

// Signature petal — inspired by the logo pinwheel flower
export function Petal({ className = "", color = "#77CABA", size = 60 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden="true"
        >
            <g fill={color}>
                {[0, 45, 90, 135, 180, 225, 270, 315].map((deg) => (
                    <path
                        key={deg}
                        d="M50 15 C 58 30, 58 42, 50 50 C 42 42, 42 30, 50 15 Z"
                        transform={`rotate(${deg} 50 50)`}
                    />
                ))}
                <circle cx="50" cy="50" r="4" fill="#EB6741" />
            </g>
        </svg>
    );
}

// Retro sun/rays
export function SunRays({ className = "", color = "#EB6741" }) {
    return (
        <svg
            viewBox="0 0 200 100"
            className={className}
            aria-hidden="true"
            fill="none"
        >
            <g stroke={color} strokeWidth="1.5" strokeLinecap="round">
                <circle cx="100" cy="100" r="30" fill={color} opacity="0.9" />
                {Array.from({ length: 13 }).map((_, i) => {
                    const a = (Math.PI * i) / 12;
                    const x1 = 100 + Math.cos(a - Math.PI) * 42;
                    const y1 = 100 + Math.sin(a - Math.PI) * 42;
                    const x2 = 100 + Math.cos(a - Math.PI) * 90;
                    const y2 = 100 + Math.sin(a - Math.PI) * 90;
                    return (
                        <line
                            key={i}
                            x1={x1}
                            y1={y1}
                            x2={x2}
                            y2={y2}
                        />
                    );
                })}
            </g>
        </svg>
    );
}

// Wavy divider
export function Waves({ className = "", color = "#1B6CA8" }) {
    return (
        <svg
            viewBox="0 0 1440 60"
            preserveAspectRatio="none"
            className={className}
            aria-hidden="true"
        >
            <path
                d="M0,30 C120,50 240,10 360,30 C480,50 600,10 720,30 C840,50 960,10 1080,30 C1200,50 1320,10 1440,30"
                stroke={color}
                strokeWidth="2"
                fill="none"
            />
            <path
                d="M0,45 C120,25 240,55 360,35 C480,15 600,45 720,25 C840,45 960,15 1080,35 C1200,55 1320,25 1440,45"
                stroke={color}
                strokeWidth="1.5"
                fill="none"
                opacity="0.6"
            />
        </svg>
    );
}

// Palm silhouette (stylised)
export function Palm({ className = "", color = "#1B6CA8" }) {
    return (
        <svg
            viewBox="0 0 200 200"
            className={className}
            aria-hidden="true"
            fill={color}
        >
            <path d="M100 190 L96 100 L104 100 L100 190 Z" />
            <path d="M100 100 C 60 90, 30 60, 20 40 C 45 50, 75 65, 100 90 Z" />
            <path d="M100 100 C 140 90, 170 60, 180 40 C 155 50, 125 65, 100 90 Z" />
            <path d="M100 100 C 70 80, 55 50, 55 25 C 75 50, 90 70, 100 95 Z" />
            <path d="M100 100 C 130 80, 145 50, 145 25 C 125 50, 110 70, 100 95 Z" />
            <path d="M100 100 C 85 70, 85 40, 100 15 C 115 40, 115 70, 100 100 Z" />
        </svg>
    );
}
